var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessNotes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 6.5C13 5.6715 12.3285 5 11.5 5H7.5C6.67154 5 6 5.6715 6 6.5V11.5C6 11.6735 6.08962 11.834 6.23731 11.9255C6.38462 12.0165 6.56847 12.0245 6.72347 11.947L9.5 10.559L12.2765 11.947C12.4315 12.0245 12.6154 12.0165 12.7627 11.9255C12.9104 11.834 13 11.6735 13 11.5V6.5Z",
    fill: "#6E6E6E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 11.927L9.5 11.677L7.171 12.8415C6.706 13.074 6.1535 13.0495 5.7115 12.776C5.269 12.5025 5 12.02 5 11.5V6.5C5 5.1195 6.1195 4 7.5 4H10V2.5C10 2.102 9.842 1.7205 9.5605 1.4395C9.2795 1.158 8.898 1 8.5 1H8V2.5C8 2.776 7.776 3 7.5 3C7.224 3 7 2.776 7 2.5V1H8V0.5C8 0.224 7.776 0 7.5 0C7.224 0 7 0.224 7 0.5V1H5.5V2.5C5.5 2.776 5.276 3 5 3C4.724 3 4.5 2.776 4.5 2.5V1H5.5V0.5C5.5 0.224 5.276 0 5 0C4.724 0 4.5 0.224 4.5 0.5V1H3V2.5C3 2.776 2.776 3 2.5 3C2.224 3 2 2.776 2 2.5V1H3V0.5C3 0.224 2.776 0 2.5 0C2.224 0 2 0.224 2 0.5V1H1.5C1.102 1 0.720499 1.158 0.439499 1.4395C0.157999 1.7205 0 2.102 0 2.5C0 4.76 0 10.24 0 12.5C0 12.898 0.157999 13.2795 0.439499 13.5605C0.720499 13.842 1.102 14 1.5 14C3.2315 14 6.7685 14 8.5 14C8.898 14 9.2795 13.842 9.5605 13.5605C9.842 13.2795 10 12.898 10 12.5V11.927Z",
    fill: "#6E6E6E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4,
    r: 4,
    fill: "#5627D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessNotes);
export default __webpack_public_path__ + "static/media/process-notes.9c1517c2d68e7dbd29b1fac4ae30b132.svg";
export { ForwardRef as ReactComponent };